import React from 'react';
import { useTranslation } from 'react-i18next';
import RewardView from '@/views/settings/rewards/RewardView';
import { useGiveawayControllerGetRewardsQuery } from '@/store/services/MidleNestApi.service';
import { Outlet } from 'react-router-dom';

export default function Rewards() {
  const { t } = useTranslation();
  const { data: rewards } = useGiveawayControllerGetRewardsQuery();

  return (
    <div className='flex flex-col gap-y-10 w-full'>
      <h3 className='text-xl leading-7 font-bold text-center md:text-left dark:text-white'>
        {t('Rewards')}
      </h3>
      <div className='p-10 bg-white dark:bg-black/20 rounded-3xl'>
        {rewards?.length ? (
          <div className='bg-white rounded-3xl mx-auto  flex flex-col md:mt-0 relative'>
            <div>
              <table className='text-sm md:text-base w-full '>
                <thead>
                  <tr className='font-semibold'>
                    <td className='hidden lg:table-cell'>{t('Title')}</td>
                    {/* <td className='hidden lg:table-cell'>{t('Reward Token')}</td> */}
                    <td className='hidden lg:table-cell'>{t('Reward')}</td>
                    <td className='hidden lg:table-cell'>{t('Wallet')}</td>
                    <td className='hidden lg:table-cell'>{t('Distributed')}</td>
                    <td className='hidden lg:table-cell'>{t('Set Wallet')}</td>
                  </tr>
                </thead>
                <tbody className='text-sm lg:text-base divide-y divide-gray-100 dark:divide-gray-700'>
                  {rewards.map((i, k) => (
                    <RewardView key={k} {...i} />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className='flex flex-col items-center justify-center gap-y-8'>
            <div className=' flex flex-col gap-y-6 '>
              <div className=' flex flex-col items-center gap-1 text-center'>
                <div className=' text-black font-bold dark:text-white'>
                  {/* eslint-disable-next-line */}
                  {t("You don't have any reward yet")}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Outlet />
    </div>
  );
}
